import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import api from '../services/api';

export default function ContatoSelect({ clienteId, value, onChange, ...rest }) {
  const [contatos, setContatos] = useState([]);
  useEffect(() => {
    if (!clienteId) { setContatos([]); return; }
    api.get('/clientes/' + clienteId + '/contatos').then(r => setContatos(r.data || [])).catch(() => setContatos([]));
  }, [clienteId]);
  return (
    <Select allowClear showSearch optionFilterProp="label" value={value} onChange={onChange}
      placeholder={clienteId ? 'Selecione o contato' : 'Selecione o cliente primeiro'}
      options={contatos.map(c => ({ value: c.id, label: [c.nome, c.setor, c.telefone].filter(Boolean).join(' — ') }))} {...rest} />
  );
}
